/** SERP 연동 품의(169·162 등) 공용 — 진입 쿼리·저장 attributes 의 SERP 문서 번호 */

/** SERP → 작성 화면 진입 쿼리 키 — 레거시 `/intranet/approval/create?apv_type=…&type_code=…&seq=…` 와 동일 */
const ENTRY_TYPE_CODE_KEY = 'type_code';
const ENTRY_SEQUENCE_KEY = 'seq';

export type SerpDocumentRef = {
  /** SERP 문서 종류(EM201 등) — 품의 유형 코드 아님 */
  typeCode: string;
  sequence: string;
};

export const SERP_NOT_LOADED_MESSAGE =
  '데이터를 로드에 실패했습니다. 데이터 전표 확인 후 재상신해주세요';

const firstQueryValue = (raw: string | string[] | undefined) =>
  (Array.isArray(raw) ? raw[0] : raw)?.trim() || undefined;

/** 진입 쿼리 → SERP 문서. 둘 중 하나라도 없으면 없음 */
export const getEntrySerpDocument = (
  query: Record<string, string | string[] | undefined>,
): SerpDocumentRef | undefined => {
  const typeCode = firstQueryValue(query[ENTRY_TYPE_CODE_KEY]);
  const sequence = firstQueryValue(query[ENTRY_SEQUENCE_KEY]);
  return typeCode && sequence ? { typeCode, sequence } : undefined;
};

export const formatSerpText = (value: unknown): string =>
  value === null || value === undefined ? '' : String(value);

const readString = (raw: unknown): string | null =>
  typeof raw === 'string' && raw.trim() ? raw.trim() : null;

/** 저장 attributes → 다시 조회할 SERP 문서 */
export const parseSerpDocumentRef = (
  attributes: unknown,
): SerpDocumentRef | null => {
  if (!attributes || typeof attributes !== 'object') return null;
  const record = attributes as Record<string, unknown>;
  const typeCode = readString(record.typeCode);
  const sequence = readString(record.sequence);
  return typeCode && sequence ? { typeCode, sequence } : null;
};

/** 저장 attributes.content(표 HTML) */
export const parseSerpContent = (attributes: unknown): string | null => {
  if (!attributes || typeof attributes !== 'object') return null;
  return readString((attributes as Record<string, unknown>).content);
};
